import StockLevelPreview from "./StockLevelPreview";

const PrintStockLevel: React.FC = () => {
  return (
    <div className="inner-container">
      <StockLevelPreview />
    </div>
  );
};

export default PrintStockLevel;
